import { Navigate } from "react-router-dom";
import { ConnectionGuard } from "@/components/ui/shared/layout/ConnectionGuard";
import type { PermissionArea } from "@/hooks/usePermissions";
import MobileChatList from "./pages/MobileChatList";
import MobileConversation from "./pages/MobileConversation";
import MobileContacts from "./pages/MobileContacts";
import MobileCrm from "./pages/MobileCrm";

export interface MobileRouteConfig {
  path: string;
  element: React.ReactElement;
  permission?: PermissionArea;
  /** Fallback in pt-BR; `titleKey` wins when present. */
  title?: string;
  /** i18n key under the common namespace, e.g. routes.conversas */
  titleKey?: string;
  /** Exibe a barra de abas inferior (apenas nas telas raiz) */
  showTabBar?: boolean;
}

export const MobileRoutes: MobileRouteConfig[] = [
  {
    path: "/m",
    element: <Navigate to="/m/chat" replace />,
  },
  {
    path: "/m/chat",
    element: (
      <ConnectionGuard>
        <MobileChatList />
      </ConnectionGuard>
    ),
    permission: "chat",
    title: "Conversas",
    titleKey: "routes.conversas",
    showTabBar: true,
  },
  {
    path: "/m/chat/:contactId",
    element: (
      <ConnectionGuard>
        <MobileConversation />
      </ConnectionGuard>
    ),
    permission: "chat",
    title: "Conversa",
    titleKey: "routes.conversa",
  },
  {
    path: "/m/contatos",
    element: <MobileContacts />,
    permission: "contatos",
    title: "Contatos",
    titleKey: "menu.contatos",
    showTabBar: true,
  },
  {
    path: "/m/crm",
    element: <MobileCrm />,
    permission: "crm",
    title: "CRM",
    titleKey: "menu.crm",
    showTabBar: true,
  },
];
